export default "__VITE_ASSET__EOBvqV7QHO9ofF20TDGjNQ__"